import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { ResponsiveContext } from 'grommet';
import { connect } from 'react-redux';
import { TableWrapper } from 'containers/Tables';
import { CurrencyInfo } from 'components/CurrencyInfo';
import { FiatConverter } from 'containers/FiatConverter';
import { ButtonNew, Box, Paragraph, Text, Heading } from 'components/Wrapped';
import { formatNumberToPlaces, nestedTranslate } from 'utils';
import { LowContrast } from 'components/Helpers/PrettyNumberTZ';
import { setHideLowBalances, setHideBalances } from 'redux/actions/userSettings';

import styles from 'pages/Wallet/Wallet.module.scss';

const WalletTable = ({
  currencySettings,
  portfolios,
  t: translate,
  extraProps,
  tradingPairsByCurrency,
  history,
  enableCryptoFeatures,
  showBalanceToggle = true,
  hideLowBalances,
  hideBalances,
  setHideLowBalances,
  setHideBalances,
  currencyCode,
}) => {
  // const [hideLowBalance, setHideLowBalance] = useState(false);
  // const [hideBalances, setHideBalances] = useState(false);
  const [currentPortfolios, setPortfolios] = useState(Object.values(portfolios));
  const size = useContext(ResponsiveContext);

  useEffect(() => {
    let currenciesMGOKX = [];
    Object.values(currencySettings).forEach((element) => {
      if (!_.isEqual(element.walletType, 'MGOKX-NDBroker')) {
        currenciesMGOKX.push(element);
      }
    });

    let newPortfolios;
    if (hideLowBalances) {
      newPortfolios = Object.values(portfolios)
        .filter(({ btcValue }) => btcValue > 0e-4)
        .map((singleValue) => singleValue);
    } else {
      newPortfolios = Object.values(portfolios);
    }

    let portfoliosMGOKX = newPortfolios.filter((el1) => currenciesMGOKX.some((el2) => el1.currency === el2.shortName));
    setPortfolios(portfoliosMGOKX);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolios, hideLowBalances, setPortfolios]);

  const t = nestedTranslate(translate, 'tables.walletOverview');
  const currencies = currencySettings;

  const formatBalance = (value) => {
    return formatNumberToPlaces(value, 2, { trim: false, thousandSeparated: true });
  };

  const renderBtcValue = (value) =>
    value ? !hideBalances ? <LowContrast>{`${formatBalance(value, 'BTC')} BTC`}</LowContrast> : '********' : null;

  const renderBalance = (btcType) => ({ value, original }) => {
    const { currency } = original;
    const btcValue = original[btcType];

    return (
      <Box pad="none" align="start" fill={true}>
        <Text>{!hideBalances ? `${formatBalance(value, currency)}` : '********'}</Text>
        <Text>
          {!hideBalances ? (
            <React.Fragment>
              {!_.isEqual(currency, currencyCode) && <FiatConverter walletBalance={value} currency={currency} color="lowContrast" />}
            </React.Fragment>
          ) : (
            '********'
          )}
        </Text>
        {!_.isEqual(currency, 'BTC') && <React.Fragment>{enableCryptoFeatures && <Text>{renderBtcValue(btcValue)}</Text>}</React.Fragment>}
      </Box>
    );
  };

  const walletButton = ({ type, currency }) => {
    const isEnabled = _.get(currencies, `${currency}.${type}Enabled`);
    // const extraProps =
    //   type === 'deposit'
    //     ? { color: 'accent-1', margin: { bottom: 'small' } }
    //     : {};

    if (isEnabled) {
      return (
        <ButtonNew
          style={{ paddingLeft: '0px', paddingRight: '0px' }}
          onClick={() => history.push(`/wallet/${type}s/${currency}`)}
          label={
            <Box pad="4px 4px" width="fit-content" style={{ backgroundColor: '#242f35', fontSize: '12px', borderRadius: '11px' }}>
              {type === 'deposit' ? 'Пополнить' : 'Вывести'}
            </Box>
          }
          theme="gray"
          width={'fit-content'}
        />
      );
    }

    return <ButtonNew theme="gray" disabled={true} label={translate(`buttons.${type}`)} />;
  };

  const renderEmptyCell = () => (
    <Box fill={true} justify="center" align="center" pad="small">
      <Paragraph>-</Paragraph>
    </Box>
  );

  const getExpanded = () => {
    let expanded = {};

    Object.values(currentPortfolios).forEach((__, index) => {
      expanded[index] = true;
    });
    return expanded;
  };

  const renderNote = (currency) => {
    const note = t(`currencyNote.${currency}`, '');
    if (!note) {
      return null;
    }

    return (
      <Box pad="small" fill={false}>
        <Box pad="small" background="background-3" flex={false}>
          <Paragraph>{note}</Paragraph>
        </Box>
      </Box>
    );
  };

  const renderActions = ({ value: currency }) => {
    // const tradingPairs = tradingPairsByCurrency[currency] || [];

    // const menuItems = tradingPairs.map((singleTradingPair) => ({
    //   label: `${singleTradingPair.baseCurrency}/${singleTradingPair.quoteCurrency}`,
    //   onClick: () => history.push(`/trade/${singleTradingPair.baseCurrency}-${singleTradingPair.quoteCurrency}`),
    // }));

    return _.get(currencySettings, `${currency}.walletType`) !== 'SecurityToken' ? (
      <Box pad="none" direction="row" justify="start" gap="20px">
        {walletButton({ type: 'deposit', currency })}
        {walletButton({ type: 'withdrawal', currency })}
        {/* {menuItems.length >= 1 && (
          <Menu
            label={
              <Text color="primary" size="small" hoverColor="text">
                {t('trade')}
              </Text>
            }
            // color="primary"
            items={menuItems}
            size="small"
          />
        )} */}
      </Box>
    ) : (
      renderEmptyCell()
    );
  };

  return (
    <Box background="#0A171E" round="15px" width={{ min: '100%' }} margin={size === 'small' ? { bottom: '40px' } : undefined}>
      {/* {showBalanceToggle && (
        <Box pad="small" direction="row" gap="small">
          <CheckBox
            checked={hideLowBalances}
            onChange={() => setHideLowBalances(!hideLowBalances)}
            label={t('lowBalances')}
          />
        </Box>
      )} */}
      {size === 'small' && (
        <Heading level={2} size="21px" margin={{ top: '47px', bottom: '10px' }} textAlign="start">
          Активы
        </Heading>
      )}
      <TableWrapper
        data={Object.values(currentPortfolios)}
        fileName="portfolio"
        isFilterable={size !== 'small'}
        widthForFilterInput="15%"
        filterBy={['currency']}
        columns={[
          {
            expander: true,
            show: false,
          },
          {
            Header: 'Валюта',
            accessor: 'currency',
            Cell: ({ value: currency }) => {
              return (
                <div className={styles.coinWrap}>
                  <CurrencyInfo currency={currency} hasFullName={true} hasIcon={true} withLink={false} />
                </div>
              );
            },
          },
          {
            Header: 'Баланс',
            accessor: 'balance',
            Cell: renderBalance('balanceBtcValue'),
          },
          ...(size !== 'small'
            ? [
                {
                  Header: 'В процессе',
                  accessor: 'balance_in_trade',
                  Cell: renderBalance('balanceInTradeBtcValue'),
                },
                {
                  show: false,
                  accessor: 'btcValue',
                },
                {
                  Header: 'Действия',
                  id: 'actions',
                  accessor: 'currency',
                  Cell: renderActions,
                  sortable: false,
                },
              ]
            : []),
          // {
          //   Header: t('trade'),
          //   id: 'trade',
          //   accessor: 'currency',
          //   Cell: ({ value: currency }) => {
          //     const tradingPairs = tradingPairsByCurrency[currency];
          //     if (!tradingPairs) {
          //       return renderEmptyCell();
          //     }
          //     const menuItems = tradingPairs.map((singleTradingPair) => ({
          //       label: `${singleTradingPair.baseCurrency}/${singleTradingPair.quoteCurrency}`,
          //       onClick: () =>
          //         history.push(
          //           `/trade/${singleTradingPair.baseCurrency}-${singleTradingPair.quoteCurrency}`,
          //         ),
          //     }));

          //     return (
          //       // <Box fill={true} justify="center" align="center" pad="small">
          //         <Menu label={t('trade')} items={menuItems} plain size="small" />
          //       // </Box>
          //     );
          //   },
          // },
        ]}
        defaultSorted={[
          {
            id: 'btcValue',
            desc: true,
          },
          {
            id: 'currency',
          },
        ]}
        showPagination={false}
        minRows={Object.values(portfolios).length || 10}
        pageSize={1000}
        SubComponent={({ original: { currency } }) => renderNote(currency)}
        expanded={getExpanded()}
        background="transparent"
        headBackground="transparent"
        sortShadowColor="transparent"
        {...extraProps}
      />
    </Box>
  );
};

WalletTable.propTypes = {
  hideActions: PropTypes.bool.isRequired,
};

WalletTable.defaultProps = {
  hideActions: false,
};

const mapStateToProps = ({
  portfolio,
  exchangeSettings: {
    currencySettings,
    settings: { enableCryptoFeatures },
    currencyCode,
  },
  markets: { tradingPairsByCurrency },
  userSettings: { hideBalances, hideLowBalances },
}) => ({
  portfolios: portfolio.portfolios,
  currencySettings,
  enableCryptoFeatures,
  tradingPairsByCurrency,
  hideBalances,
  hideLowBalances,
  currencyCode,
});

export default withNamespaces()(withRouter(connect(mapStateToProps, { setHideLowBalances, setHideBalances })(WalletTable)));
